/* tslint:disable */
/* eslint-disable */
/**
 * LMS API
 * This is LMS API Documentation.
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface StripeCoupon
 */
export interface StripeCoupon {
    /**
     * 
     * @type {string}
     * @memberof StripeCoupon
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeCoupon
     */
    object?: string;
    /**
     * 
     * @type {number}
     * @memberof StripeCoupon
     */
    amount_off?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StripeCoupon
     */
    created?: number;
    /**
     * 
     * @type {string}
     * @memberof StripeCoupon
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof StripeCoupon
     */
    duration?: StripeCouponDurationEnum;
    /**
     * 
     * @type {number}
     * @memberof StripeCoupon
     */
    duration_in_months?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StripeCoupon
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof StripeCoupon
     */
    percent_off?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StripeCoupon
     */
    max_redemptions?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StripeCoupon
     */
    redeem_by?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StripeCoupon
     */
    times_redeemed?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StripeCoupon
     */
    valid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StripeCoupon
     */
    livemode?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof StripeCoupon
     */
    applies_to?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof StripeCoupon
     */
    metadata?: object;
}

/**
    * @export
    * @enum {string}
    */
export enum StripeCouponDurationEnum {
    Once = 'once',
    Repeating = 'repeating',
    Forever = 'forever'
}



